import React from 'react'
import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Foundations'

type Props = {
  title: React.ReactNode
  subTitle?: string
  rightAlignedComponent?: React.ReactNode
}

export const PageHeader: React.FC<Props> = ({ title, subTitle, rightAlignedComponent }) => {
  return (
    <HeaderStyled data-testid='PageHeader'>
      <div>
        <h1>{title}</h1>
        {subTitle && <p>{subTitle}</p>}
      </div>

      {rightAlignedComponent ? rightAlignedComponent : null}
    </HeaderStyled>
  )
}

// ======
// Styles
// ======

const HeaderStyled = styled.header({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: spacing.smx2,
  boxSizing: 'border-box',
  minHeight: '5.2rem',
  padding: `${spacing.smx1} ${spacing.md}`,

  background: colors.lavender[750],
  color: colors.white,

  '> div': {
    fontFamily: font.family.primary,

    '> *': { margin: 0, padding: 0 },

    '> h1': {
      display: 'flex',
      alignItems: 'center',
      textTransform: 'unset',
      textAlign: 'left',
      background: 'unset',
      color: colors.white,
      fontWeight: font.weight.semibold,
      fontSize: font.size.xl2.fontSize,
      lineHeight: font.size.xl2.lineHeight,
      letterSpacing: font.size.xl2.letterSpacing,
    },

    '> p': {
      color: colors.lavender[100],
      textAlign: 'left',
      fontWeight: font.weight.medium,
      fontSize: font.size.lg.fontSize,
      lineHeight: font.size.lg.lineHeight,
      letterSpacing: font.size.lg.letterSpacing,
    },
  },

  '> a, > button': {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  '> a': {
    textDecoration: 'none',
    color: 'unset',
    userSelect: 'none',
    transition: 'opacity 0.25s ease-out',
    WebkitTapHighlightColor: 'transparent',

    '@media (hover: hover) and (pointer: fine)': { ':hover': { opacity: 0.75 } },
    ':active': { opacity: 0.5 },
  },
})
